import {IApiModel} from 'app/original-models/api-model.interface';
import moment from 'moment';

export class ConnectedAccounts implements IApiModel<ConnectedAccounts> {
    id: string;
    bankConnectionId: number;
    name: string;
    displayName: string;
    // bankName: string;
    // icon: string;
    // type: string;
    // iban: string;
    // bic: string;
    accountTypeName: string;
    alias: string;
    iban: string;
    accountCurrency: string;
    total: number;
    balance: number;
    reporting_balance: number;
    limit_reporting_amount: number;
    limit: number;
    bankId: number;
    bank_connection: any;
    bankName: any;
    bankBic: any;
    status: any;
    profile: any;
    bankConnection: any;
    isDeleting?: boolean;
    offline: boolean;
    disconnected: boolean;
    integrated: boolean;
    apiAccountId: number;
    limits: any[];
    last_successful_update: string | null;

    getApiModel(): any {
        return {}
    }

    setFromApiModel(apiModel: any): this {
        this.id = apiModel.id;
        this.offline = apiModel.status === 'OFFLINE';
        this.disconnected = apiModel.status === 'DISCONNECTED';
        this.integrated = apiModel.status === 'API';
        this.bankConnectionId = apiModel.bank_connection;
        this.bankId = apiModel.bank_connection ? apiModel.bank_connection.id : null;
        this.name = apiModel.name;
        this.accountTypeName = apiModel.type_name;
        this.iban = apiModel.iban;

        this.accountCurrency = apiModel.accountCurrency;
        this.limit = 0;
        this.limits = apiModel.limits;
        this.getClosestLimit();

        this.total = apiModel.total;
        this.balance = apiModel.balance;
        this.reporting_balance = apiModel.reporting_balance;
        this.limit_reporting_amount = apiModel.limit_reporting_amount;
        this.bankName = apiModel.bank ? apiModel.bank.name : apiModel.bank_name;
        this.status = apiModel.status;
        this.profile = apiModel.profile;
        this.bankBic = apiModel.bank_bic;
        this.alias = apiModel.alias;
        this.apiAccountId = apiModel.banking_api_account;
        this.last_successful_update = apiModel.last_successful_update || null;

        this.displayName = this.alias ? this.alias : (apiModel.name ? apiModel.name : this.bankName);
        return this;
    }

    getClosestLimit() {
        if (!this.limits || !this.limits?.length) {
            return;
        }

        let pastLimits = this.limits.filter(i => moment(i.start_date).isSameOrBefore(moment())).sort((a, b) => {
            if (a.start_date < b.start_date) {
                return 1;
            }
            if (a.start_date > b.start_date) {
                return -1;
            }
            return 0;
        });
        if (pastLimits?.length) {
            this.limit = pastLimits[0].limit_reporting_amount ?? pastLimits[0].limit;
        }
    }
}
